import { Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { useDialog } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { CustomerStateDialog } from "./CustomerStateDialog";
import { AdminListItemDto } from "./types";


export function CustomerStateListPage() {
    const [useCustomerStatesStore] = useState(() => createListStore<AdminListItemDto>({
        path: "settings/customerStates",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "id", label: "Id", width: 120 },
            { column: "code", label: "Code", width: 120 },
            { column: "description", label: "Description", width: 250 },
        ],
    }));

    const customerStates = useCustomerStatesStore(p => ({ selectedItem: p.selectedItem }));
    const editDialog = useDialog(close => <CustomerStateDialog close={close} customerStates={customerStates.selectedItem!}
        onChange={() => { useCustomerStatesStore.getState().fetch(); }} />, "xs");
    return <>
        {editDialog.render()}
        <PageTitle title="Customer states" />
        {renderListStore(useCustomerStatesStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={customerStates.selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
            ]),
        })}
    </>;
}
